/* ==========================================================================
   fe-hex-flip — tap-to-flip for the decoration hexagons on touch devices.

   Hover does the flipping everywhere else, so this only wires up on devices
   that have no hover at all. A tap flips the hexagon under it and unflips any
   other; a tap on empty stage unflips them all. Same behaviour as the inline
   script in hex-flip-grid.liquid, moved to a custom element so it loads once
   with `defer` rather than once per section instance.
   ========================================================================== */

if (!customElements.get('fe-hex-flip')) {
  customElements.define(
    'fe-hex-flip',
    class FeHexFlip extends HTMLElement {
      connectedCallback() {
        if (!matchMedia('(hover: none)').matches) return;
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = (event) => {
        const hex = event.target.closest('.fe-decoration__hex');

        for (const open of this.querySelectorAll('.fe-decoration__hex.is-flipped')) {
          if (open !== hex) open.classList.remove('is-flipped');
        }

        if (hex) hex.classList.toggle('is-flipped');
      };
    }
  );
}
